import { FETCH_USER_TYPE_DETAILS, SET_USER_TYPE_DETAILS } from '../../actions/userDataActions';

let defaultState = {
    details: null,
    measurementType: null,
    userType: null
}

const userTypeReducer = (state = Object.assign({}, defaultState), action) => {
    switch (action.type) {
        case FETCH_USER_TYPE_DETAILS: {
            state ={
                ...state,
                details : action.payload
            }
            break;
        }
        case SET_USER_TYPE_DETAILS: {
            state = {
                ...state,
                ...action.payload
            }
            break;
        }   
        default:
            break;
    }
    return state;
}

export default userTypeReducer;
